import apiSlice from './ApiSlice';

export const registrationRequestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
     //Get All
     getAllRegistrationRequest: builder.query({
        providesTags: ["registration-link"],
        query: (body) => {
          return {
            url: "/registration-request",
            method: "POST",
            body,
          };
        },
      }),

      getAllPendingRegistrationRequest: builder.query({
        providesTags: ["registration-link"],
        query: () => {
          return {
            url: "/registration-request/count",
            method: "GET",
          };
        },
      }),

      
    // Change Status Approved
    changeStatusInApprove: builder.mutation({
        invalidatesTags: ["registration-link"],
        query: (id) => {
          return {
            url: `/registration-request/${id}/update-action?action=APPROVE`,
            method: "PUT",
          };
        },
      }),
       // Spam Status
     changeSpamStatus: builder.mutation({
        invalidatesTags: ["registration-link"],
        query: (id) => {
          return {
            url: `/registration-request/${id}/update-action?action=SPAM`,
            method: "PUT",
          };
        },
      }),
  
  }),
});

export const { useGetAllRegistrationRequestQuery , useChangeStatusInApproveMutation , useChangeSpamStatusMutation , useGetAllPendingRegistrationRequestQuery} = registrationRequestApi;